import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { CellClickedEvent, ColDef, GridReadyEvent, GridSizeChangedEvent } from 'ag-grid-community';
import { HomepageDataService } from 'src/app/services/homepageData/homepageData.service';
import { DistributorsDataService } from 'src/app/services/distributorsData/distributorsData.service';
import { TanksDataService } from 'src/app/services/tanksData/tanksData.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss'],
})
export class AdminDashboardComponent implements OnInit {
  public charts: string[] = [];
  public kpis: string[] = [];
  isLoading: boolean = false;
  kpiData: any[] = [];
  kpi: any;
  chartData: { id: number, name: string, type: string, netChange: number, value: string }[] = [];

    
  public defaultColDef: ColDef = {
        sortable: false,
        filter: false,
      };


    watchlistColDefs: ColDef[] = [
        { field: 'serialNumber', sortable: false, filter: false, tooltipField: "Serial Number", headerName: "Serial Number", initialSort: 'asc'},
        { field: 'distributor', sortable: false, filter: false, tooltipField: "Distributor", headerName: "Distributor"}
    ];

    newUnitsColDefs: ColDef[] = [
        { field: 'unitId', sortable: false, filter: false, tooltipField: "Unit Id", headerName: "Unit Id", initialSort: 'asc'},
        { field: 'date', sortable: false, filter: false, tooltipField: "Installed", headerName: "Installed"}
    ];


  constructor(
    private _homepageDataService: HomepageDataService,
    private _router: Router,
    private _distributorsDataService: DistributorsDataService,
    private _tanksDataService: TanksDataService
  ) {

  }

  ngOnInit() {
    /* if ("homepageAdminChartData" in sessionStorage) {
      let chartJson = sessionStorage.getItem('homepageAdminChartData') || '{}';
      this.chartData = JSON.parse(chartJson);
    } else {
      this.isLoading = true;
      this._homepageDataService.getAdminChartData$().pipe(
        map((data: any) => {
          this.chartData = data;
          sessionStorage.setItem('homepageAdminChartData', JSON.stringify(this.chartData));
          if (this.charts.length < 1) {
            for (let x = 0; x < this.chartData.length; x++) {
              this.charts.push(data[x].id);
            }
          }
          return data;
        })
      ).subscribe((data: any) => this.chartData = data);
    }

    if ("homepageAdminKpiData" in sessionStorage) {
      let kpiJson = sessionStorage.getItem("homepageAdminKpiData") || '{}';
      this.kpiData = JSON.parse(kpiJson);

      if ("homepageAdminKpis" in sessionStorage) {
        let kpisJson = sessionStorage.getItem("homepageAdminKpis") || '{}';
        this.kpis = JSON.parse(kpisJson);
      }
    } else {
      this.isLoading = true;
      this._homepageDataService.getAdminKPIData$().pipe(
        map((data: any) => {
          this.kpiData = data;
          sessionStorage.setItem('homepageAdminKpiData', JSON.stringify(this.kpiData));
          if (this.kpis.length < 1) {
            for (let x = 0; x < this.kpiData.length; x++) {
              this.kpis.push(data[x].id);
            }
          }
          sessionStorage.setItem('homepageAdminKpis', JSON.stringify(this.kpis));
          this.isLoading = false;
          return data;
        })
      ).subscribe((data: any) => this.kpiData = data);
    }

    this.getOtherCacheData(); */

    //Temporarily re-routing away from dashboard
    let url: string = "/dashboard/distributors/distributors";
    this._router.navigate([url]);
    
  }

  onGridReady(params: GridReadyEvent) {
    params.api.sizeColumnsToFit();
    params.api.resetRowHeights();
    params.api.setDomLayout('autoHeight');
  }

  onGridSizeChanged(params: GridSizeChangedEvent) {
    params.api.sizeColumnsToFit();
  }

  onCellClicked($event: CellClickedEvent) {

}

  getOtherCacheData() {
    //distributors cache:
    if ("distData" in sessionStorage) {
      //do nothing
    } else {
      this._distributorsDataService.getDistributorsData$.pipe(
        map((data: any) => {
          sessionStorage.setItem('distData', JSON.stringify(data));
          return data;
        })
      ).subscribe((data: any) => sessionStorage.setItem('distData', JSON.stringify(data)));
    }

    //tanks cache:
    if ("tanksData" in sessionStorage) {
      //do nothing
    } else {
      this._tanksDataService.getTankDetails$(localStorage.getItem('distid') ?? "").pipe(
        map((data: any) => {
          sessionStorage.setItem('tanksData', JSON.stringify(data));
          return data;
        })
      ).subscribe((data: any) => sessionStorage.setItem('tanksData', JSON.stringify(data)));
    }

  }


}
